export const formatBobCurrency = (value) => `Bs ${Number(value || 0).toFixed(2)}`;
